export default {"src":"/_next/static/media/0x463e3d1e01d048fdf872710f7f3745b5cdf50d0e.7b531822.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};